import { render } from "./EmailCancellation.vue?vue&type=template&id=bdc59182"
import script from "./EmailCancellation.vue?vue&type=script&lang=js"
export * from "./EmailCancellation.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "bdc59182"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bdc59182', script)) {
    api.reload('bdc59182', script)
  }
  
  module.hot.accept("./EmailCancellation.vue?vue&type=template&id=bdc59182", () => {
    api.rerender('bdc59182', render)
  })

}

script.__file = "src/components/EmailCancellation.vue"

export default script